import * as Flux from 'flux';
import * as FluxUtils from 'flux/utils';

import { AppDispatcher, DispatcherBaseAction } from '../dispatcher/AppDispatcher';
import { ActionConstants } from '../constants/ActionConstants';
import { UrlHelper } from '../utils/UrlHelper';
import { UrlActions } from '../actions/UrlActions';

// Submodules
import { Dict } from '../submodules/utils/Types';

class UrlArgumentsStoreClass extends FluxUtils.ReduceStore<Dict, unknown> {
    constructor(dispatcher: Flux.Dispatcher<DispatcherBaseAction>) {
        super(dispatcher);

        window.addEventListener('hashchange', () => {
            UrlActions.updateUrlArgumentsStore();
        });
    }

    public getInitialState(): Dict {
        return this.getStateFromUrl();
    }

    public reduce(state: Dict, action: DispatcherBaseAction): Dict {
        // Note: this function should be `pure` -> we have to return a copy
        // of the current state if some property was changed

        switch (action.actionType) {
            case ActionConstants.HASH_CHANGED:
                return this.getStateFromUrl();
            default:
                return state;
        }

    }

    private getStateFromUrl(): Dict {
        return UrlHelper.parseQueryString(window.location.hash.substr(1));
    }
}

export let UrlArgumentsStore: UrlArgumentsStoreClass = new UrlArgumentsStoreClass(AppDispatcher);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/stores/UrlArgumentsStore.ts